import { Button, DropdownMenu, Flex } from '@workwhile/ui'
import { UserPlus, Pencil, Ban } from 'lucide-react'
import { useAssignmentWorkflowsContextStateValue } from '../Calendar/context/AssignmentWorkflowsProvider'
import { useGateValue } from '@statsig/react-bindings'
import { FeatureGates } from 'lib/statsig/feature_gates'

interface ListViewControlsProps {
  selectedShifts: string[]
  selectedTab: string
}

export const ListViewControls = ({
  selectedShifts,
  selectedTab,
}: ListViewControlsProps) => {
  const { editShiftFlow, requestWorkersFlow, cancelShiftFlow } =
    useAssignmentWorkflowsContextStateValue()
  const shouldEnableLTActions = useGateValue(FeatureGates.EnableLTAActions)

  return (
    <Flex alignItems="center" justifyContent="flex-end" zIndex={1}>
      <DropdownMenu
        trigger={
          <Button variant="primary" disabled={selectedTab !== 'upcoming'}>
            Actions
          </Button>
        }
      >
        {selectedTab === 'upcoming' && (
          <>
            <DropdownMenu.Item
              onClick={(e) => {
                if (selectedShifts.length === 0) {
                  e.preventDefault()
                  return
                }
                requestWorkersFlow.open(selectedShifts)
              }}
              disabled={selectedShifts.length === 0}
            >
              <Flex as="span" alignItems="center" style={{ gap: 8 }}>
                <UserPlus size={14} />
                Request Workers
              </Flex>
            </DropdownMenu.Item>
            {shouldEnableLTActions ? (
              <>
                <DropdownMenu.Item
                  onClick={(e) => {
                    if (selectedShifts.length === 0) {
                      e.preventDefault()
                      return
                    }
                    editShiftFlow.open(selectedShifts)
                  }}
                  disabled={selectedShifts.length === 0}
                >
                  <Flex as="span" alignItems="center" style={{ gap: 8 }}>
                    <Pencil size={14} />
                    Edit Shift Times
                  </Flex>
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  onClick={(e) => {
                    if (selectedShifts.length === 0) {
                      e.preventDefault()
                      return
                    }
                    cancelShiftFlow.open(selectedShifts)
                  }}
                  disabled={selectedShifts.length === 0}
                >
                  <Flex as="span" alignItems="center" style={{ gap: 8 }}>
                    <Ban size={14} />
                    Cancel Shifts
                  </Flex>
                </DropdownMenu.Item>
              </>
            ) : null}
          </>
        )}
      </DropdownMenu>
    </Flex>
  )
}
